import React from 'react'

type PlanOptionProps = {
  sale_period: string
  estimation: number
  active: boolean
}

export const PlanOption: React.FC<PlanOptionProps> = ({ sale_period, estimation, active }) => {
  return (
    <div className={`plan-option-box flex justify-center items-center rounded-lg border ${active ? 'border-black-700' : ''}`}>
      <div className="flex flex-col justify-center items-center">
        <p className={`text-base font-semibold ${active ? 'text-black' : 'text-gray-400'}`}>{sale_period}</p>
        <p className={`text-base font-bold ${active ? 'text-black' : 'text-gray-400'}`}>{estimation.toLocaleString()}</p>
      </div>
    </div>
  )
}
